<template>
  <swiper ref="mySwiper" class="swiper" :options="swiperOption" @slide-change="activeIndexChange">
    <swiper-slide v-for="(slideImage, index) in sliderImages" :key="index">
      <img :src="slideImage" class="img-fluid"/>
    </swiper-slide>
    <template v-slot:button-prev v-if="activeSliderIndex > 0">
      <div class="swiper-button-prev" @click="prevSlide"></div>
    </template>
    <template v-slot:button-next v-if="activeSliderIndex !== sliderImages.length - 1">
      <div class="swiper-button-next" @click="nextSlide"></div>
    </template>
  </swiper>
</template>

<script>
export default {
    name: 'my-pension-slider',

    methods: {
        prevSlide () {
            this.$refs.mySwiper.swiperInstance.slidePrev();
            this.updateActiveSliderIndex(this.$refs.mySwiper.swiperInstance.activeIndex);
        },
        nextSlide () {
            this.$refs.mySwiper.swiperInstance.slideNext();
            this.updateActiveSliderIndex(this.$refs.mySwiper.swiperInstance.activeIndex);
        },
        activeIndexChange () {
            this.updateActiveSliderIndex(this.$refs.mySwiper.swiperInstance.activeIndex);
        },
        updateActiveSliderIndex (index) {
            this.activeSliderIndex = index;
            this.$emit('setSliderIndex', index);
        },
    },
    data () {
        return {
            images: [
                '/img/homepage/my-pension-slider.png',
                '/img/homepage/edit-details.png',
                '/img/homepage/forms-example.png',
                '/img/homepage/my-pension-modeller.png',
                '/img/homepage/payslips.png',
            ],
            swiperOption: {},
            activeSliderIndex: 0,
        };
    },
    computed: {
        sliderImages () {
            if (this.$store.state.clientConfig.homepage.swiperImages && this.$store.state.clientConfig.homepage.swiperImages.length) return this.customImages;
            if (!this.showPensionPaySlip) {
                const payslipIndex = this.images.indexOf('/img/homepage/payslips.png');
                return this.images.filter((image, index) => index !== payslipIndex);
            }
            return this.images;
        },
        customImages () {
            return this.$store.state.clientConfig.homepage.swiperImages;
        },
        modellerComingSoon () {
            return this.$store.state.clientConfig.modellerComingSoon;
        },
        clientConfig () {
            return this.$store.state.clientConfig;
        },
        showPensionPaySlip () {
            // Novuna fix - remove reference to payslips
            if (this.clientConfig.newHomepage.hiddenSections && Array.isArray(this.clientConfig.newHomepage.hiddenSections)) {
                return !this.clientConfig.newHomepage.hiddenSections.includes('pensionPayslip');
            }
            return true;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_mixins.scss';

.swiper {
  position: initial !important;
  .swiper-button-prev {
    left: -2rem !important;

    @include responsive('sm') {
      left: 0rem !important;
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    width: 3rem;
    height: 3rem;
    background-color: rgba(148, 148, 148, 0.672);
    border-radius: 50%;
    z-index: 9;
    @include responsive('sm') {
      width: 2rem;
      height: 2rem;
    }
    &::after {
      font-size: 1.4rem !important;
      color: white;

      @include responsive('sm') {
        font-size: 1rem !important;
      }
    }
  }
  .swiper-button-next {
    right: -2rem !important;
    @include responsive('sm') {
      right: 0rem !important;
    }
  }
}
</style>
